<template>
  <div>
    <div v-if="showTitle">
      <span class="bloctitle"
        >{{ companyTitle }}
        <a
          v-if="showSelectedCompany && !selectedCompany.isFinal"
          v-on:click="setSearchMode"
          class="modifylink"
        >
          {{ $t("Company.SelectCompany.CHANGE_COMPANY_SELECTION_LINK") }}
        </a></span
      >
      <div class="divider">
        <v-divider></v-divider>
      </div>
    </div>
    <br />
    <v-layout row>
      <SearchCompany
        :id="id"
        v-if="!showSelectedCompany"
        ref="searchCompanyAutoComplete"
        :placeHolder="autoCompletePlaceholder"
        :countryFlag="countryFlag"
        :selectedCountry="selectedCountry"
        :searchFilterIsEnabled="searchFilterIsEnabled"
        :searchByIdTriggerRules="selectedCountryCompanyIdentifierRule"
        :countries="countries"
        @hideResult="hideResultList"
        @showResult="showResultList"
        @initializeResult="initializeResult"
        @searchListCompanies="searchListCompanies"
        @selectedCountryChanged="selectedCountryChanged"
      />
    </v-layout>
    <v-layout row>
      <SearchCompanyResult
        v-if="showCompaniesResults"
        ref="companyResult"
        :loadCompanies="loadCompanies"
        :companies="companies"
        @selectCompany="selectAutoCompleteCompany"
        @hideResult="hideResultList"
      />
      <SelectedCompanyInfos v-if="showSelectedCompany" :company="selectedCompany" />
    </v-layout>
  </div>
</template>
<script>
import coverApi from "@/services/CoverApi";
import transactorApi from "@/services/TransactorApi";
import { mapState } from "vuex";
import SearchCompany from "@/components/cover/newcover/company/SearchCompany";
import SearchCompanyResult from "@/components/cover/newcover/company/SearchCompanyResult";
import SelectedCompanyInfos from "@/components/cover/newcover/company/SelectedCompany";
export default {
  data() {
    return {
      showCompaniesResults: false,
      loadCompanies: false,
      showSelectedCompany: false,
      rulesCompanySearch: [
        {
          countryCode: "FR",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "SIREN",
              rule: /\d{9}$/,
              label: "SIREN",
            },
            {
              searchType: "Id",
              companyIdentifier: "SIRET",
              rule: /\d{14}$/,
              label: "SIRET",
            },
          ],
        },
        {
          countryCode: "BE",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "TVABE",
              rule: /^BE\d{10}$/,
              label: "TVABE",
            },
          ],
        },
        {
          countryCode: "US",
          searchFilterIsEnabled: true,
          rules: [
            { searchType: "Id", companyIdentifier: "DUN", rule: /\d{9}$/, label: "DUNS" },
          ],
        },
        {
          countryCode: "CA",
          searchFilterIsEnabled: false,
          rules: [
            { searchType: "Id", companyIdentifier: "DUN", rule: /\d{9}$/, label: "DUNS" },
          ],
        },
        {
          countryCode: "GB",
          searchFilterIsEnabled: false,
          rules: [
            { searchType: "Id", companyIdentifier: "CRO", rule: /\d{8}$/, label: "CRO" },
          ],
        },
        {
          countryCode: "IT",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "COFIS",
              rule: /\d{11}$/,
              label: "COFIS",
            },
          ],
        },
        {
          countryCode: "SE",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "RNSE",
              rule: /\d{10}$/,
              label: "RNSE",
            },
          ],
        },
        {
          countryCode: "AD",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "NRT",
              rule: /^[a-zA-Z]{1}-\d{6}-[a-zA-Z]{1}$/,
              label: "NRT",
            },
          ],
        },
        {
          countryCode: "AT",
          searchFilterIsEnabled: false,

          rules: [
            {
              searchType: "Id",
              companyIdentifier: "FN",
              rule: /^(\d{6})([a-zA-Z])$/,
              label: "FN",
            },
          ],
        },
        {
          countryCode: "BG",
          searchFilterIsEnabled: false,

          rules: [
            {
              searchType: "Id",
              companyIdentifier: "TVABG",
              rule: /^(BG\d{9})$/,
              label: "TVABG",
            },
          ],
        },
        {
          countryCode: "CH",
          searchFilterIsEnabled: false,

          rules: [
            {
              searchType: "Id",
              companyIdentifier: "COCCHE",
              rule: /CHE-(\d{3}(.)){2}(\d{3})/,
              label: "COCCHE",
            },
          ],
        },
        {
          countryCode: "CY",
          searchFilterIsEnabled: false,

          rules: [
            {
              searchType: "Id",
              companyIdentifier: "VATCY",
              rule: /^CY\d{8}[A-Z]$/,
              label: "VATCY",
            },
          ],
        },
        {
          countryCode: "CZ",
          searchFilterIsEnabled: false,

          rules: [
            { searchType: "Id", companyIdentifier: "ICO", rule: /(\d{8})/, label: "ICO" },
          ],
        },
        {
          countryCode: "DK",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "TVADK",
              rule: /^(DK\d{8})$/,
              label: "TVADK",
            },
          ],
        },
        {
          countryCode: "ES",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "CIF",
              rule: /^[a-zA-Z0-9]{9}$/,
              label: "CIF",
            },
          ],
        },
        {
          countryCode: "FI",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "TVAFI",
              rule: /^FI\d{8}$/,
              label: "TVAFI",
            },
          ],
        },
        {
          countryCode: "GR",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "VATGR",
              rule: /^EL\d{9}$/,
              label: "VATGR",
            },
          ],
        },
        {
          countryCode: "HU",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "VATHU",
              rule: /^HU\d{8}$/,
              label: "VATHU",
            },
          ],
        },
        {
          countryCode: "IE",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "TVAIE",
              rule: /^(IE[a-zA-Z0-9]{8})|(?:(?:IE)?\d{7}[A-Z0-9][A-HJ-NP-TV-Z]|\d[A-Z]\d{5}[A-Z0-9]|\d{8}|(?:\d{6}|\d{3})\/[A-Z]|[A-Z]\d{7}|[0-9A-Z]{8}|\d{7}[A-Z]{2})$/,
              label: "TVAIE",
            },
          ],
        },
        {
          countryCode: "LT",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "VATLT",
              rule: /^LT\d{9,14}$/,
              label: "VATLT",
            },
          ],
        },
        {
          countryCode: "LU",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "IBLC",
              rule: /^LU\d{8}$/,
              label: "IBLC",
            },
          ],
        },
        {
          countryCode: "NO",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "RNNO",
              rule: /^\d{9}$/,
              label: "RNNO",
            },
          ],
        },
        {
          countryCode: "NL",
          searchFilterIsEnabled: false,
          rules: [
            { searchType: "Id", companyIdentifier: "KVK", rule: /^\d{8}$/, label: "KVK" },
          ],
        },
        {
          countryCode: "PT",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "RNPT",
              rule: /^\d{9}$/,
              label: "RNPT",
            },
          ],
        },
        {
          countryCode: "RS",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "RNRS",
              rule: /^\d{9}$/,
              label: "RNRS",
            },
          ],
        },
        {
          countryCode: "DE",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "CREF",
              rule: /^\d{10}$/,
              label: "CREF",
            },
          ],
        },
        {
          countryCode: "SG",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "ROC",
              rule: /^[a-zA-Z0-9]{10}$/,
              label: "ROC",
            },
          ],
        },
        {
          countryCode: "MY",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "ROCMY",
              rule: /^\d{12}$/,
              label: "ROC Malaysia",
            },
          ],
        },
        {
          countryCode: "HK",
          searchFilterIsEnabled: false,
          rules: [
            {
              searchType: "Id",
              companyIdentifier: "RNHK",
              rule: /^\d{1,9}$/,
              label: "Reg number Hong Kong",
            },
          ],
        },
      ],
      companies: [],
      selectedCompany: {
        id: "",
        name: "",
        mainIdentifierCode: "",
        mainIdentifierValue: "",
        streetNumber: "",
        streetName: "",
        postCode: "",
        city: "",
        country: "",
      },
    };
  },
  props: ["id", "countryFlag", "selectedCountry", "companyTitle", "countries"],
  components: {
    SearchCompany,
    SearchCompanyResult,
    SelectedCompanyInfos,
  },
  methods: {
    showResultList() {
      this.showCompaniesResults = true;
    },
    hideResultList() {
      this.showCompaniesResults = false;
    },
    initializeResult() {
      this.searchCompanies = [];
    },
    async searchListCompanies(criteria) {
      if (this.$refs.companyResult) {
        this.$refs.companyResult.initPagination();
      }
      let selectedCountrySearchRules = this.rulesCompanySearch.find(
        (f) => f.countryCode.toUpperCase() === this.selectedCountry.toUpperCase()
      );
      let companiesResult = [];
      this.loadCompanies = true;
      this.companies = [];
      let fixedText = criteria.text.replace(/\s/g, "");
      let usedRule = selectedCountrySearchRules
        ? selectedCountrySearchRules.rules.find((f) => f.rule.test(fixedText))
        : undefined;
      if (usedRule) {
        let result = await coverApi.searchCompaniesByIdentifier(
          this.selectedCountry.toUpperCase(),
          usedRule.companyIdentifier,
          fixedText
        );
        if (result) {
          companiesResult = [this.mapCompany(result)];
        }
      } else {
        let result = await coverApi.searchCompaniesByName(
          this.selectedCountry.toUpperCase(),
          criteria.text,
          criteria.state,
          criteria.city,
          criteria.postCode,
          criteria.phone
        );
        if (result) {
          companiesResult = this.mapCompanies(result);
        }
      }
      this.loadCompanies = false;
      this.companies = companiesResult;
    },
    async selectAutoCompleteCompany(company) {
      this.companies = [];
      this.showCompaniesResults = false;
      this.showSelectedCompany = true;
      if (this.$isEmpty(company.id)) {
        company.id = await transactorApi.fetchCompanyByExternalId(
          this.selectedCountry,
          company.mainIdentifierCode.toUpperCase(),
          company.mainIdentifierValue
        );
      }
      this.selectedCompany = company;
      this.$emit("validateForm");
    },
    mapCompanies(result) {
      return result.map((item) => {
        return this.mapCompany(item);
      });
    },
    mapCompany(result) {
      let countryItem = this.countriesWithFlag.find(
        (f) => f.countryCode.toUpperCase() === result.Address.CountryCode.toUpperCase()
      );
      let mainIdentifier = result.ExternalIds.find(function (transactor) {
        return transactor.IsPrincipal === true;
      });
      return {
        id: result.Id,
        name: this.$toTitleCase(result.Name),
        mainIdentifierCode: mainIdentifier
          ? this.$toTitleCase(mainIdentifier.ExternalService)
          : "",
        mainIdentifierValue: mainIdentifier
          ? this.$toTitleCase(mainIdentifier.ExternalId)
          : "",
        streetNumber: this.$toTitleCase(result.Address.StreetNumber),
        streetName: this.$toTitleCase(result.Address.StreetName),
        postCode: result.Address.PostCode,
        city: this.$toTitleCase(result.Address.City),
        country: countryItem ? countryItem.countryName : "",
      };
    },
    setSearchMode() {
      this.companies = [];
      this.showCompaniesResults = false;
      this.showSelectedCompany = false;
      this.selectedCompany = undefined;
      this.$emit("validateForm");
    },
    validate() {
      return (
        !this.$isEmpty(this.selectedCompany) && !this.$isEmpty(this.selectedCompany.id)
      );
    },
    getCompanyId() {
      return !this.$isEmpty(this.selectedCompany) ? this.selectedCompany.id : "";
    },
    selectedCountryChanged(country) {
      this.$emit("selectedCountryChanged", country);
    },
  },
  computed: {
    ...mapState("countries", ["countriesWithFlag"]),
    selectedCountrySearchRules: function () {
      let selectedCountrySearchRules = this.rulesCompanySearch.find(
        (f) => f.countryCode.toUpperCase() === this.selectedCountry.toUpperCase()
      );
      return selectedCountrySearchRules;
    },
    selectedCountryCompanyIdentifierRule: function () {
      if (this.selectedCountrySearchRules) {
        return this.selectedCountrySearchRules.rules;
      } else {
        return undefined;
      }
    },
    autoCompletePlaceholder: function () {
      if (
        !this.selectedCountrySearchRules ||
        this.selectedCountrySearchRules.length === 0
      ) {
        return this.$t("Company.SelectCompany.COMPANY_PLACEHOLDER");
      } else {
        let identifierList = this.selectedCountrySearchRules.rules.map((x) => x.label);
        return this.$t("Company.SelectCompany.COMPANY_OR_NUMBER_PLACEHOLDER", {
          identifierListForSelectedCountry: `${identifierList.join(", ")}`,
        });
      }
    },
    searchFilterIsEnabled: function () {
      return (
        (this.selectedCountrySearchRules &&
          this.selectedCountrySearchRules.searchFilterIsEnabled) ||
        false
      );
    },
    showTitle: function () {
      return this.companyTitle || this.companyTitle.length > 0;
    },
  },
};
</script>
<style scoped>
.bloctitle {
  font-size: 15px;
}
.modifylink {
  margin-left: 13px;
}
</style>
